import { IAppState, TActions } from '../../../common/state';
import { ESignInTriggerModalActions } from '../actions/signInTriggerModal';

export function signInTriggerModal(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case ESignInTriggerModalActions.open:
      return {
        ...state,
        isSignInTriggerModalOpen: true,
      };
    case ESignInTriggerModalActions.close:
      return {
        ...state,
        isSignInTriggerModalOpen: false,
      };
    default:
      return state;
  }
}
